<div class="dropdown" dropdown>
  <button type="button" class="btn header-item" dropdownToggle data-toggle="dropdown" aria-haspopup="false"
    aria-expanded="false">
    <i class="bx bx-copyright"></i>
    {{ selectedLicense ? selectedLicense.organisationName : '' }}
    <i class="mdi mdi-chevron-down"></i>
  </button>
  <div class="dropdown-menu" *dropdownMenu style="max-height: 50vh;overflow: auto;">
    <dropdown-item *ngFor="let license of licenseList" (click)="selectedLicense = license;selectionChanged(license.id)">
      {{ license.organisationName }}
    </dropdown-item>
  </div>
</div>